import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import EasyTooltip from 'components/EasyTooltip';
import Flex from 'components/Flex';
import Icon from 'components/Icon';
import Tab from 'components/Tab';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AdminShortcuts(_ref) {
  var isAdmin = _ref.isAdmin,
    myTeamsLink = _ref.myTeamsLink;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Flex, {
    align: "stretch",
    gap: "xxxs",
    mr: "-xs",
    children: [myTeamsLink && /*#__PURE__*/_jsx(EasyTooltip, {
      content: t('navbar_my_teams'),
      placement: "bottom",
      children: /*#__PURE__*/_jsxs(Tab, {
        as: NavLink,
        to: myTeamsLink,
        activeClassName: "is-active",
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "team",
          mx: "xxs"
        }), /*#__PURE__*/_jsx(VisuallyHidden, {
          children: t('navbar_my_teams')
        })]
      })
    }), isAdmin && /*#__PURE__*/_jsx(EasyTooltip, {
      content: t('navbar_admin'),
      placement: "bottom",
      children: /*#__PURE__*/_jsxs(Tab, {
        as: "a",
        href: "/admin",
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "settings",
          mx: "xxs"
        }), /*#__PURE__*/_jsx(VisuallyHidden, {
          children: t('navbar_admin')
        })]
      })
    })]
  });
}
export default AdminShortcuts;